var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.workorder)?_c('v-row',{staticClass:"py-0",style:(_vm.workorder.tipo == 'intestazione'
      ? { backgroundColor: '#3f51b5' }
      : _vm.workorder.colore_riga
      ? _vm.workorder.colore_riga
      : _vm.workorder.macchina_impegnata == 1
      ? { backgroundColor: '#EE9922' }
      : { backgroundColor: _vm.riga.colore_riga })},_vm._l((_vm.riga.colonne
      ? _vm.riga.colonne.filter((c) => c.validita == 1)
      : []),function(colonna,i){return _c('WorkorderLayoutColumn',{key:i,attrs:{"colonna":colonna,"gestione_team_enabled":_vm.gestione_team_enabled,"workorder":_vm.workorder,"hasIntestazione":_vm.hasIntestazione},on:{"button_click":_vm.handleButtonClick}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }